import React from 'react';
import Slider from '@mui/material/Slider';
import Grid from '@mui/material/Grid';
import './Likert3SidesAnswer.scss'

function Likert3SidesResponse(props) {
  const neutralPortion = props.answer[1].percent
  const leftPortion = props.answer[0].percent
  const rightPortion = props.answer[2].percent
  const scale = neutralPortion + leftPortion + rightPortion
  const totalPercents = scale + props.answer[3].percent
  const sliderWidthPercentage = 100 * scale / totalPercents
  const thumbWidthPercentage = neutralPortion / scale * 100
  const greyRecWidthPercentage = 100 - sliderWidthPercentage


  const sliderStyle = {
    '& input[type="range"]': {
      WebkitAppearance: 'slider-vertical',
    },
    width: '100%',
    height: 100,
    margin: 0,
    '& .MuiSlider-track': {
      border: 'none',
      borderRadius: 0,
      color: '#B2292D',
      opacity: 1
    },
    '& .MuiSlider-thumb': {
      height: 100,
      width: `${thumbWidthPercentage}%`,
      border: '4px solid black',
      backgroundColor: '#f4d06f',
      borderRadius: 0,
      marginLeft: `${thumbWidthPercentage/2}%`,
    },
    '& .MuiSlider-rail': {
      color: '#5B6586',
      opacity: 1,
      borderRadius: 0
    },
    '& .MuiSlider-markLabel': {
      margin: '80px 0',
      fontSize: '14pt',
    },
    '& .MuiSlider-mark': {
      opacity: 0,
      fontSize: '14pt',
    },
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center'
  } 

  const rectangleStyle = {
    height: 100,
    width: '100%',
    background: '#E7DCDA'
}

  function preventHorizontalKeyboardNavigation(event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
    }
  }

  function ariaLabel(value) {
    return `Range from ${value[0]} to ${value[1]}`
  }

  return (
    <div className="likert-answer-container">
      <Grid container direction="row" justifyContent="center" alignItems="center" pb={2}>
        <Grid item width={`${sliderWidthPercentage}%`} >
          <Slider
            sx={sliderStyle}
            orientation="horizontal"
            getAriaLabel={ariaLabel}
            value={leftPortion}
            onKeyDown={preventHorizontalKeyboardNavigation}
            valueLabelDisplay="off"
            disableSwap
            disabled
          />
        </Grid>
        <Grid item width={`${greyRecWidthPercentage}%`} justifyContent='center' alignItems='center' display='flex'>
          <div style={rectangleStyle}></div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Likert3SidesResponse;